import Loader from "@/components/ui/Loader/Loader";
import { dataProps } from "@/models/data.model";
import { Flex } from "@radix-ui/themes";
import { FC, JSX } from "react";

import { useFinishedResults } from "@/features/_shared/hooks/useFinishedResults";
import EndscreenView from "./EndscreenView";

const EndscreenUI: FC<dataProps> = (): JSX.Element => {
  const { challenge, leaderboard, loading } = useFinishedResults();

  if (loading) {
    return (
      <Flex align="center" justify="center" height="100vh">
        <Loader />
      </Flex>
    );
  }

  return <EndscreenView leaderboard={leaderboard} challenge={challenge} />;
};

export default EndscreenUI;
